<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import ContactModal from '../Components/ContactModal.vue'
import NavigationHeader from '../Components/NavigationHeader.vue'
import OfflineModal from '../Components/OfflineModal.vue'
import { useConfigStore } from '../Stores/config'
import { useEligibilitySubmissionStore } from '../Stores/eligibilitySubmission'

const route = useRoute()

const eligibilitySubmissionStore = useEligibilitySubmissionStore()
const configStore = useConfigStore()

const shouldShowNavigationHeader = computed<boolean>(() => {
    if (route.query.showNavigationHeader === 'false') {
        return false
    }

    if (typeof route.meta.showNavigationHeader === 'boolean') {
        return route.meta.showNavigationHeader
    }

    if (!eligibilitySubmissionStore.hasStateFilled) {
        return false
    }

    return !configStore.isKbcOrEnergyAtHomePartner
})
</script>

<template>
    <div class="flex flex-1 flex-col bg-white lg:my-8">
        <NavigationHeader v-if="shouldShowNavigationHeader" />
        <div class="relative flex flex-1 px-6 first:pt-4">
            <slot />
        </div>
        <div class="px-6 pt-6 pb-8 space-y-6">
            <slot name="footer" />
        </div>
        <OfflineModal />
        <ContactModal />
    </div>
</template>
